var i = Object.defineProperty, f = Object.defineProperties;
var s = Object.getOwnPropertyDescriptors;
var r = Object.getOwnPropertySymbols;
var l = Object.prototype.hasOwnProperty, S = Object.prototype.propertyIsEnumerable;
var p = (o, e, m) => e in o ? i(o, e, { enumerable: !0, configurable: !0, writable: !0, value: m }) : o[e] = m, t = (o, e) => {
  for (var m in e || (e = {}))
    l.call(e, m) && p(o, m, e[m]);
  if (r)
    for (var m of r(e))
      S.call(e, m) && p(o, m, e[m]);
  return o;
}, a = (o, e) => f(o, s(e));
import c, { forwardRef as y } from "react";
import R from "../lib/SSRBase.mjs";
import d from "../defs/CopySimple.mjs";
const n = y((o, e) => /* @__PURE__ */ c.createElement(R, a(t({ ref: e }, o), { weights: d })));
n.displayName = "CopySimple";
export {
  n as CopySimple
};
